import { gql, TypedDocumentNode } from "@apollo/client";

import {
  Identity,
  IdentityFederation,
  Maybe,
  MutationIdentityFederationUnlinkArgs,
  User,
} from "types/generated";

export type PersonalConnectionsFederation = Pick<
  IdentityFederation,
  "provider" | "externalID" | "externalUsername"
>;

type PersonalConnectionsIdentity = Pick<Identity, "id"> & {
  federations: PersonalConnectionsFederation[];
};

type PersonalConnectionsData = {
  viewer: Maybe<
    Pick<User, "id"> & {
      identity: PersonalConnectionsIdentity | null;
    }
  >;
};

export const GET_PERSONAL_CONNECTIONS: TypedDocumentNode<PersonalConnectionsData> = gql`
  query GetPersonalConnections {
    viewer {
      id
      identity {
        id
        federations {
          provider
          externalID
          externalUsername
        }
      }
    }
  }
`;

type IdentityFederationUnlinkData = {
  identityFederationUnlink: PersonalConnectionsIdentity | null;
};

export const IDENTITY_FEDERATION_UNLINK: TypedDocumentNode<
  IdentityFederationUnlinkData,
  MutationIdentityFederationUnlinkArgs
> = gql`
  mutation IdentityFederationUnlink($provider: FederationProvider!) {
    identityFederationUnlink(provider: $provider) {
      id
      federations {
        provider
        externalID
        externalUsername
      }
    }
  }
`;
